import { OrderTotalsPanel } from "@components/order_entry/OrderTotalsPanel/OrderTotalsPanel";
import OwButton from "@components/shared/OwButton/OwButton";
import OwTitle from "@components/shared/OwTitle/OwTitle";
import { AuthorizeNetContext } from "@contexts/AuthorizeNetContext";
import IOrder from "@models/IOrder";
import { useContext } from "react";

type Props = {
    orderModel: IOrder;
};

export const OrderPaymentAuthorizeNetReview = (props: Props) => {
    const { existingCard, newPaymentDetails, isLoading, setIsLoading, nextSlide, prevSlide } = useContext(AuthorizeNetContext);

    return (
        <div className={"OrderPaymentAuthorizeNetReview"}>
            <div>
                <OwTitle title="review_charge" tag="h3" />
                <OrderTotalsPanel
                    className="w-100"
                    order={props.orderModel}
                    isReadOnly={true}
                    orderItemType="standard"
                    shouldHidePricingFn={() => false}
                />
            </div>
            <div className="d-flex justify-content-between">
                <OwButton
                    title="prev"
                    fn={() => {
                        prevSlide();
                    }}
                />
                <OwButton
                    title="next"
                    fn={() => {
                        nextSlide();
                    }}
                />
            </div>
        </div>
    );
};
